import { Injectable } from '@angular/core';
import { Observable, catchError, first, map, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';
import { User } from '../models/user.model';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  user!: User;
  
  constructor(private apiService: ApiService,private authService: AuthService) { }

  loadUser(): Observable<any> {
    console.log('UserService: Attempting to load user data');
    return this.apiService.get(environment.provisionerUrl, '/user').pipe(
      tap(user => console.log('UserService: User data received:', user)),
      catchError(error => {
        console.error('UserService: Error loading user:', error);
        throw error;
      })
    );
  }

  public getUser(): User {
    return this.user;
  } 
    
}
